// extracted by mini-css-extract-plugin
module.exports = {"boughtThisMonth":"boughtThisMonth_boughtThisMonth__5Qqvg","boughtThisMonthMobile":"boughtThisMonth_boughtThisMonthMobile__mfTlz"};